<template>
  <div class="side-panel">
    <DashboardWidgetSlot
      v-for="slot in slots"
      :key="slot.key"
      :slot-key="slot.key"
      :slot-class="slot.class"
      :kpi-id="layout.slots[slot.key].kpiId"
      :raw-data="kpiData[slot.key]"
      :setting="setting"
      :format-widget-props="formatWidgetProps"
      :set-slot-ref="setSlotRef"
      @edit="$emit('edit-slot', slot.key)"
    />
  </div>
</template>

<script setup>
import DashboardWidgetSlot from './DashboardWidgetSlot.vue'

defineProps({
  slots: Array,
  layout: Object,
  kpiData: Object,
  setting: Boolean,
  formatWidgetProps: Function,
  setSlotRef: Function
})

defineEmits(['edit-slot'])
</script>

<style lang="scss" scoped>
.side-panel {
  height: 100%;
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
:deep(.top),
:deep(.middle) {
  height: calc(30% - 15px);
}
:deep(.bottom) {
  aspect-ratio: 1.26;
  height: calc(40% - 15px);
}
</style>
